import React, { useMemo } from 'react'
import styled from 'styled-components'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import LocalOfferOutlined from '@mui/icons-material/LocalOfferOutlined'

import { ActionCardProps } from 'types/TextAnalysis'

const Wrapper = styled.div`
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
`

const StyledIconButton = styled(IconButton)`
  opacity: 0;
  transition: opacity 0.3s ease;

  &.visible {
    opacity: 1;
  }

  /* Hide the Add tag icon for tablets and mobile devices */
  @media only screen and (max-width: 1024px) {
    display: none;
    pointer-events: none;
  }
`

const CardActions = ({
  index,
  anchorElMap,
  onClickAddTag,
  $focused,
  innerRef,
}: ActionCardProps) => {
  const isIconVisible = useMemo(
    () => Boolean(anchorElMap?.[index ?? -1]) || $focused,
    [anchorElMap, index, $focused],
  )

  return (
    <Wrapper>
      <Tooltip title="Add tag" ref={innerRef}>
        <StyledIconButton
          className={`add-tag-icon ${isIconVisible ? 'visible' : ''}`}
          onClick={onClickAddTag}
        >
          <LocalOfferOutlined fontSize="small" />
        </StyledIconButton>
      </Tooltip>
    </Wrapper>
  )
}

export default React.memo(CardActions)
